export default __webpack_public_path__ + "static/media/antenna.461c69ab.png";